export default defineNuxtRouteMiddleware(async (to, from) => {
  // Variable for breadcrumb params
  let breadcrumb = {}
  // split to check if it is coming with categories or author
  let split = (from?.matched?.[0]?.path || '').split('/')
  const fromSlug = from?.params?.slug
  const { getCategoryBySlug, getAuthorBySlug, getPostBySlug } = useBlogData()
  
  if (split[2] != '' && split[2] != ':slug()') {    

    let label = ''
    if (split[2] == "categories") {
      const { data: category } = await getCategoryBySlug(fromSlug);
      label = category.value?.category || ''
    } else if (split[2] == 'authors') {
      const { data: author } = await getAuthorBySlug(fromSlug);
      label = author.value?.name || ''
    }

    // Assign object values
    breadcrumb.type = split[2]
    breadcrumb.slug = fromSlug
    breadcrumb.label = label
    // Assign to next page params
    to.params.breadcrumb = breadcrumb
  }
  else if (fromSlug != undefined) {
    const { data: post, error: postError } = await getPostBySlug(fromSlug);
    // Assign object values
    if (postError.value) {
      throw createError({ statusCode: 404, statusMessage: 'Page not found' });
    }    
    to.params.post = post
  }
  
})